/* Don Lorino search relevance layer v12 */
const DL_SEARCH_STORAGE_KEY='dl_search_original';

const DL_SEARCH_COLORS={
  svart:['svart','black'],vit:['vit','white'],grå:['grå','grey','gray'],
  brun:['brun','brown','mocha'],beige:['beige','sand','cream'],
  röd:['röd','rött','red','burgundy','bordeaux'],rött:['röd','rött','red','burgundy','bordeaux'],
  vinröd:['vinröd','vinrött','burgundy','bordeaux'],vinrött:['vinröd','vinrött','burgundy','bordeaux'],
  rosa:['rosa','pink'],lila:['lila','purple','violet','lavender','mauve'],
  blå:['blå','blue','navy'],grön:['grön','green','olive','sage','mint'],
  gul:['gul','yellow','lemon'],orange:['orange'],turkos:['turkos','turquoise','teal'],
  guld:['guld','gold'],silver:['silver'],khaki:['khaki']
};

/* English colour names are common in Don Lorino's collection names. */
Object.entries(DL_SEARCH_COLORS).forEach(([key,terms])=>{
  terms.forEach(term=>{if(!DL_SEARCH_COLORS[term])DL_SEARCH_COLORS[term]=terms});
});

/* Named collection colours stay precise: Green must not also return Olive/Mint. */
const DL_SEARCH_EXACT_COLOR_NAMES={
  green:['green','grön'],olive:['olive'],sage:['sage'],mint:['mint'],mocha:['mocha'],
  lavender:['lavender'],mauve:['mauve'],violet:['violet'],navy:['navy'],
  cream:['cream'],sand:['sand'],lemon:['lemon'],bordeaux:['bordeaux'],burgundy:['burgundy']
};

const DL_SEARCH_COLLECTIONS={
  click:['click'],petit:['petit'],pop:['pop'],soft:['soft'],
  classic:['classic','klassisk'],flower:['flower','blomma','blommig'],
  glamour:['glamour'],tiki:['tiki']
};

const DL_SEARCH_COLLECTION_ALIASES={
  klick:'click',clik:'click',clcik:'click',clic:'click',clickk:'click',
  petti:'petit',pettit:'petit',petitt:'petit',petitit:'petit',peti:'petit',
  popp:'pop',klassik:'classic',clasik:'classic',clasic:'classic',
  flwer:'flower',flovver:'flower',glamor:'glamour'
};

const DL_SEARCH_PRODUCTS={
  halsband:['halsband','hundhalsband'],hundhalsband:['halsband','hundhalsband'],
  sele:['sele','selar','hundsele','hundselar'],selar:['sele','selar','hundsele','hundselar'],
  hundsele:['sele','selar','hundsele','hundselar'],hundselar:['sele','selar','hundsele','hundselar'],
  koppel:['koppel','hundkoppel'],hundkoppel:['koppel','hundkoppel'],
  bädd:['bädd','bäddar','hundbädd','hundbäddar'],bäddar:['bädd','bäddar','hundbädd','hundbäddar'],
  filt:['filt','filtar','hundfilt','hundfiltar'],filtar:['filt','filtar','hundfilt','hundfiltar'],
  namnbrickor:['namnbricka','namnbrickor','hundnamnbricka','hundnamnbrickor'],
  namnbricka:['namnbricka','namnbrickor','hundnamnbricka','hundnamnbrickor'],
  hundbricka:['namnbricka','namnbrickor','hundnamnbricka','hundnamnbrickor'],
  'id-bricka':['namnbricka','namnbrickor','hundnamnbricka','hundnamnbrickor'],
  utställning:['utställning','utställningskoppel','showkoppel'],
  utställningskoppel:['utställning','utställningskoppel','showkoppel'],
  showkoppel:['utställning','utställningskoppel','showkoppel'],
  påshållare:['påshållare','bajspåsehållare'],bajspåsehållare:['påshållare','bajspåsehållare'],
  rundsytt:['rundsytt','rundsydd','rundsydda']
};

const DL_SEARCH_PHRASES=[
  [/\bclick\s*pop\b/g,'click pop'],[/\bclick\s*soft\b/g,'click soft'],
  [/\bclick\s*classic\b/g,'click classic'],[/\bclick\s*flower\b/g,'click flower'],
  [/\butställnings\s+koppel\b/g,'utställningskoppel'],[/\bhund\s+halsband\b/g,'hundhalsband'],
  [/\bhund\s+sele\b/g,'hundsele'],[/\bhund\s+koppel\b/g,'hundkoppel'],
  [/\bnamn\s+brick(?:a|or)\b/g,'namnbricka'],[/\bid\s+brick(?:a|or)\b/g,'id-bricka'],
  [/\bvin\s+röd(?:t)?\b/g,'vinröd'],[/\bhalsaband\b/g,'halsband'],
  [/\butstälningskoppel\b/g,'utställningskoppel'],[/\butställningskopel\b/g,'utställningskoppel'],
  [/\bbajspåse\s+hållare\b/g,'bajspåsehållare']
];

function dlNormalizeSearch(query){
  let value=(query||'').trim().toLocaleLowerCase('sv-SE').replace(/\*+$/,'').replace(/\s+/g,' ');
  DL_SEARCH_PHRASES.forEach(([pattern,replacement])=>{value=value.replace(pattern,replacement)});
  return value;
}

function dlPrefixKey(token,map){
  if(token.length<2)return null;
  const keys=Object.keys(map).filter(key=>key.startsWith(token));
  return keys.length===1?keys[0]:null;
}

function dlEditDistance(a,b){
  const rows=Array.from({length:a.length+1},()=>Array(b.length+1).fill(0));
  for(let i=0;i<=a.length;i++)rows[i][0]=i;
  for(let j=0;j<=b.length;j++)rows[0][j]=j;
  for(let i=1;i<=a.length;i++)for(let j=1;j<=b.length;j++){
    rows[i][j]=Math.min(rows[i-1][j]+1,rows[i][j-1]+1,rows[i-1][j-1]+(a[i-1]===b[j-1]?0:1));
    if(i>1&&j>1&&a[i-1]===b[j-2]&&a[i-2]===b[j-1])rows[i][j]=Math.min(rows[i][j],rows[i-2][j-2]+1);
  }
  return rows[a.length][b.length];
}

function dlCollectionKey(token){
  if(DL_SEARCH_COLLECTIONS[token])return token;
  if(DL_SEARCH_COLLECTION_ALIASES[token])return DL_SEARCH_COLLECTION_ALIASES[token];
  const prefix=dlPrefixKey(token,DL_SEARCH_COLLECTIONS);
  if(prefix)return prefix;
  if(token.length<4)return null;
  const matches=Object.keys(DL_SEARCH_COLLECTIONS).filter(key=>dlEditDistance(token,key)<=1);
  return matches.length===1?matches[0]:null;
}

function dlTermsForToken(token){
  const collectionKey=dlCollectionKey(token);
  if(collectionKey)return DL_SEARCH_COLLECTIONS[collectionKey];
  if(DL_SEARCH_EXACT_COLOR_NAMES[token])return DL_SEARCH_EXACT_COLOR_NAMES[token];
  const colorKey=DL_SEARCH_COLORS[token]?token:dlPrefixKey(token,DL_SEARCH_COLORS);
  if(colorKey)return DL_SEARCH_COLORS[colorKey];
  const productKey=DL_SEARCH_PRODUCTS[token]?token:dlPrefixKey(token,DL_SEARCH_PRODUCTS);
  if(productKey)return DL_SEARCH_PRODUCTS[productKey];
  return [token];
}

function dlSearchQuery(query,withPrefix=false){
  const normalized=dlNormalizeSearch(query);
  if(!normalized)return '';
  return normalized.split(' ').map(token=>{
    const unique=[...new Set(dlTermsForToken(token))];
    const terms=withPrefix?unique.map(term=>`${term.replace(/\*+$/,'')}*`):unique;
    return terms.length>1?`(${terms.join(' OR ')})`:terms[0];
  }).join(' AND ');
}

function dlTrackSearch(eventName,detail={}){
  const payload={event:eventName,...detail};
  window.dispatchEvent(new CustomEvent(`donlorino:${eventName}`,{detail:payload}));
  if(Array.isArray(window.dataLayer))window.dataLayer.push(payload);
  if(window.Shopify&&window.Shopify.analytics&&typeof window.Shopify.analytics.publish==='function'){
    window.Shopify.analytics.publish(`dl_${eventName}`,detail).catch(()=>{});
  }
}

function dlPrepareFullSearch(form,input,source){
  const original=input.value.trim();
  if(!original)return false;
  sessionStorage.setItem(DL_SEARCH_STORAGE_KEY,original);
  let type=form.querySelector('input[name="type"]');
  if(!type){type=document.createElement('input');type.type='hidden';type.name='type';form.appendChild(type)}
  type.value='product';
  input.value=dlSearchQuery(original,true);
  dlTrackSearch('search_submit',{search_term:original,search_source:source});
  return true;
}

class PredictiveSearch {
  constructor(){this.container=document.getElementById('Search-Drawer');if(!this.container)return;this.form=this.container.querySelector('form.searchform');this.buttons=document.querySelectorAll('.thb-quick-search');this.input=this.container.querySelector('input[type="search"]');this.results=this.container.querySelector('.side-panel-content--has-tabs');this.cache=new Map();this.controller=null;if(!this.form||!this.input||!this.results)return;this.bind()}
  bind(){this.form.addEventListener('submit',event=>{if(!dlPrepareFullSearch(this.form,this.input,'drawer'))event.preventDefault()});this.input.addEventListener('input',debounce(()=>this.change(),100));this.buttons.forEach(button=>button.addEventListener('click',event=>{event.preventDefault();if(OverlayManager.isOpen(this.container)){OverlayManager.close(this.container);return}this.position();this.stamp();OverlayManager.open(this.container);setTimeout(()=>this.input.focus({preventScroll:true}),80);dispatchCustomEvent('search:open')}));this.results.addEventListener('click',event=>{if(event.target.closest('#search-results-submit')){this.form.requestSubmit?this.form.requestSubmit():this.form.submit();return}const productLink=event.target.closest('a[href*="/products/"]');if(productLink)dlTrackSearch('search_result_click',{search_term:this.query(),search_source:'preview',result_url:productLink.href});const tab=event.target.closest('[data-search-tab]');if(tab)this.selectTab(tab.dataset.searchTab)});window.addEventListener('resize',debounce(()=>{if(OverlayManager.isOpen(this.container))this.position()},100))}
  position(){const header=document.querySelector('.header-section');this.container.style.setProperty('--dl-search-top',`${header?Math.max(0,header.getBoundingClientRect().bottom):0}px`)}
  query(){return this.input.value.trim()}
  change(){const query=this.query();if(!query){this.results.classList.remove('active','loading');this.results.innerHTML='';return}this.results.classList.add('active');this.load(query)}
  load(query){if(this.controller)this.controller.abort();this.controller=new AbortController();const mapped=dlSearchQuery(query,false);const key=`${query.toLocaleLowerCase('sv-SE')}::${mapped}`;if(this.cache.has(key)){this.render(this.cache.get(key));return}this.results.classList.add('loading');const params=new URLSearchParams({q:mapped,'resources[type]':'product,collection','resources[limit]':'5','resources[options][unavailable_products]':'last','resources[options][fields]':'title,product_type,vendor,variants.title,variants.sku,tag',section_id:'predictive-search'});fetch(`${theme.routes.predictive_search_url}?${params}`,{signal:this.controller.signal,headers:{Accept:'text/html'}}).then(response=>{if(!response.ok)throw Error(response.status);return response.text()}).then(text=>{const section=new DOMParser().parseFromString(text,'text/html').querySelector('#shopify-section-predictive-search');if(!section)throw Error('Missing section');if(this.cache.size>=40)this.cache.delete(this.cache.keys().next().value);this.cache.set(key,section.innerHTML);this.render(section.innerHTML)}).catch(error=>{if(error.name==='AbortError')return;this.results.classList.remove('loading');this.results.innerHTML='<div class="dl-search__content"><p>Sökningen kunde inte laddas. Tryck Enter för att visa resultaten.</p></div>'})}
  render(html){this.results.innerHTML=html;this.results.classList.remove('loading')}
  selectTab(name){this.results.querySelectorAll('[data-search-tab]').forEach(tab=>{const active=tab.dataset.searchTab===name;tab.classList.toggle('active',active);tab.setAttribute('aria-selected',active?'true':'false')});this.results.querySelectorAll('[data-search-panel]').forEach(panel=>{const active=panel.dataset.searchPanel===name;panel.classList.toggle('active',active);panel.hidden=!active})}
  stamp(){const template=this.container.querySelector('.thb-predictive-search--promotion-template');if(template)template.replaceWith(template.content.cloneNode(true))}
}

function dlRestoreSearchPage(){
  if(!location.pathname.includes('/search'))return;
  const original=sessionStorage.getItem(DL_SEARCH_STORAGE_KEY);
  if(!original)return;
  document.querySelectorAll('form.searchform input[name="q"]').forEach(input=>{input.value=original});
  const summary=document.querySelector('[data-dl-search-summary]');
  if(summary){const count=summary.dataset.dlSearchCount||'0';summary.textContent=`${count} sökresultat för “${original}”`}
  const empty=document.querySelector('[data-dl-search-empty]');
  if(empty)empty.textContent=`Vi hittade inga produkter för “${original}”.`;
  if(document.querySelector('.collection-empty'))dlTrackSearch('search_no_results',{search_term:original});
}

const dlInitSearch=()=>{
  new PredictiveSearch();
  document.querySelectorAll('form.searchform[action]').forEach(form=>{if(form.closest('#Search-Drawer'))return;form.addEventListener('submit',event=>{const input=form.querySelector('input[name="q"]');if(!input||!dlPrepareFullSearch(form,input,'search_page'))event.preventDefault()})});
  dlRestoreSearchPage();
  document.addEventListener('click',event=>{const link=event.target.closest('#product-grid a[href*="/products/"]');if(link)dlTrackSearch('search_result_click',{search_term:sessionStorage.getItem(DL_SEARCH_STORAGE_KEY)||'',search_source:'results_page',result_url:link.href})});
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',dlInitSearch,{once:true});else dlInitSearch();
